import { AppState } from '../models/state/appState';

/**
 * Selected the user command types state.
 * @param state
 */
export function selectUserCommandTypes(state: AppState) {
  return state.userCommandTypes;
}
